var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-title mb-35"},[_c('h3',[_vm._v(_vm._s(_vm.title)+", "+_vm._s(_vm.me.name)+"!")]),_c('p',{staticClass:"font-18 text-pre-wrap",domProps:{"innerHTML":_vm._s(_vm.subtitle)}})])}
var staticRenderFns = []

export { render, staticRenderFns }